import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominaDocumentosLayoutsh2hCompletados', {
    template: template,
    controller: NominaDocumentosLayoutsh2hCompletadosComponent,
    bindings: {
      data: '<',
      onChange: '&',
    },
  })

function NominaDocumentosLayoutsh2hCompletadosComponent() {
  let $ctrl = this

  $ctrl.$onChanges = $onChanges
  $ctrl.$onInit= $onInit
  $ctrl.actualizar = actualizar
  $ctrl.expandido = false
  $ctrl.seleccionado = null

  function $onInit() {
  }

  function $onChanges(changes) {
    if (changes.data) {
      $ctrl.activos = $ctrl.data.filter(function (item) {
        return item.colaboradores > 0
      })

      $ctrl.inactivos = $ctrl.data.filter(function (item) {
        return item.colaboradores === 0
      })

      $ctrl.expandido = false
    }
  }

  function actualizar(data) {
    if (!$ctrl.seleccionado)
      return

    angular.extend($ctrl.seleccionado, data)

    $ctrl.data = [].concat($ctrl.data)

    $ctrl.onChange({$event: {data: $ctrl.data}})
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/documentos/layoutsh2h/completados/component.js